$('.js-waypoint').on('click', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($this.attr('href'));

  if (!$element.length) {
    return;
  }

  $('html, body').animate(
    {
      scrollTop: $element.offset().top - $('.header').outerHeight()
    },
    1000
  );

  $(window).trigger('bind');

  if ($this.closest('nav').length) {
    $this
      .parent()
      .addClass('current')
      .siblings()
      .removeClass('current');

    if ($(window).width() < 768) {
      const currentText = $this.text();

      $this
        .closest('ul')
        .slideUp()
        .removeClass('is-expanded')
        .prev()
        .removeClass('is-active')
        .text(currentText);
    }
  }
});



// WEBPACK FOOTER //
// ./../src/assets/js/waypoint.js